<template>
  <div class="data-action-bar">
    <!-- 刷新按钮 -->
    <el-button v-if="refreshVisible" size="small" icon="el-icon-refresh" @click="$emit('refresh')">刷新</el-button>
    
    <!-- 导出按钮（单层） -->
    <template v-if="exportScopes.length === 1">
      <el-button size="small" icon="el-icon-download" 
        :loading="exportLoading" @click="handleExport('header')">
        导出
      </el-button>
    </template>
    
    <!-- 导出下拉按钮（双层） -->
    <el-dropdown v-else trigger="click" @command="handleExport">
      <el-button size="small" icon="el-icon-download" :loading="exportLoading">
        导出 <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="scope in exportScopes" :key="scope" :command="scope">
          {{ scope === 'header' ? '仅头表' : '头表+明细' }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 导入按钮 -->
    <el-upload
      v-if="showImportButton"
      :show-file-list="false"
      :http-request="handleImport"
      action=""
      accept=".xlsx,.xls"
      style="display:inline-block;margin-left:8px"
    >
      <el-button size="small" icon="el-icon-upload2" :loading="importLoading">导入</el-button>
    </el-upload>

    <!-- 错误详情弹窗 -->
    <el-dialog title="导入结果" :visible.sync="importDialogVisible" width="500px">
      <p>成功: <b style="color:green">{{ importResult.success }}</b> 条 | 失败: <b style="color:red">{{ importResult.fail }}</b> 条</p>
      <div v-if="importResult.errors.length" style="max-height:300px;overflow-y:auto">
        <p v-for="(err,i) in importResult.errors" :key="i" style="color:red">{{ err }}</p>
      </div>
      <span slot="footer">
        <el-button @click="importDialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DataActionBar',
  props: {
    exportScopes: { type: Array, default: () => ['header'] },
    importVisible: { type: Boolean, default: true },
    refreshVisible: { type: Boolean, default: true },
    exportApi: { type: Function, required: true },
    importApi: { type: Function, default: null },
    exportFileName: { type: String, default: '导出数据' },
    // 任务A 新增：导入按钮控制 / 查询条件 / 货位页豁免
    showImport: { type: Boolean, default: true },
    queryParams: { type: Object, default: () => ({}) },
    isLocationPage: { type: Boolean, default: false }
  },
  computed: {
    // ERP 连接时（erpType ≠ NONE）基础数据页只读：导入按钮隐藏，导出始终可用
    erpEditable() {
      return (this.$store.getters.erpType || 'NONE') === 'NONE'
    },
    // 货位管理豁免：不受 ERP 只读限制
    showImportButton() {
      return this.importVisible && this.showImport && (this.erpEditable || this.isLocationPage)
    }
  },
  data() {
    return {
      exportLoading: false,
      importLoading: false,
      importDialogVisible: false,
      importResult: { success: 0, fail: 0, errors: [] }
    }
  },
  methods: {
    async handleExport(scope) {
      this.exportLoading = true
      try {
        const res = await this.exportApi({ scope, ...this.queryParams })
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.href = url
        const suffix = scope === 'full' ? '_明细' : ''
        link.download = `${this.exportFileName}${suffix}_${Date.now()}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败: ' + (e.message || '未知错误'))
      } finally {
        this.exportLoading = false
      }
    },
    async handleImport({ file }) {
      if (!this.importApi) {
        this.$message.warning('导入功能未配置')
        return
      }
      this.importLoading = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await this.importApi(formData)
        const data = res.data || res
        this.importResult = {
          success: data.success || 0,
          fail: data.fail || 0,
          errors: data.errors || []
        }
        this.importDialogVisible = true
        this.$emit('import-success')
      } catch (e) {
        this.$message.error('导入失败: ' + (e.message || '未知错误'))
      } finally {
        this.importLoading = false
      }
    }
  }
}
</script>
